import _ from "lodash";
import employeeActions from "../../../actions/employeeActions";
import { getAccessProfile } from "../../../reducers/sessionReducer";
import sortObjectsArrayByProperty from "../../../utils/sortObjectsArrayByProperty";

const fiSpreadsheetInputFields = (formValues, dispatch, state) => {
  const fields = [
    {
      name: "headersLine",
      label: "Linha dos cabeçalhos",
      width: 180,
    },
    {
      name: "sheetName",
      label: "Nome da aba",
      width: 180,
    },
    {
      name: "file",
      label: "Arquivo de planilha",
      type: "file",
    },
    {
      name: "headers",
      label: "Cabeçalhos",
      type: "group",
      fields: [
        { name: "issuer", label: "Emissor", width: 200 },
        { name: "code", label: "Código", width: 200 },
        { name: "maturityDate", label: "Vencimento", width: 200 },
        { name: "rating", label: "Rating", width: 200 },
        { name: "agency", label: "Agência", width: 200 },
        { name: "rate", label: "Taxa", width: 200 },
        { name: "rateType", label: "Indexador", width: 200 },
        // {
        //   name: "availableQuantity",
        //   label: "Quantidade Indicativa",
        //   width: 200,
        // },
        // { name: "unitPrice", label: "Preço Unitário", width: 200 },
        { name: "grossRoa", label: "Receita Estimada", width: 200 },
      ],
    },
  ];

  // if (getAccessProfile(state) === "Gestor") {
  //   fields.unshift({
  //     name: "assessorId",
  //     label: "Assessor",
  //     type: "object-select",
  //     meta: { valueKey: "id", labelKey: "name" },
  //     options: [],
  //     async: {
  //       fetch: () => dispatch(employeeActions.fetchAll()),
  //       fetchDelay: 500,
  //       mapSuccessfulResult: (response) =>
  //         sortObjectsArrayByProperty(
  //           Object.values(response.data.entities.employees),
  //           "name",
  //         ),
  //       mapProps: ({ response, ...others }) => ({
  //         ...others,
  //         options: response,
  //       }),
  //     },
  //     width: 320,
  //   });
  // } else {
  //   _.remove(fields, (field) => field.name !== "file");
  // }
  return fields;
};

export default fiSpreadsheetInputFields;
